// https://weatherless.ru/javascript/js-other/vue-multilanguage/

import Vue from 'vue'
import { MLInstaller, MLCreate, MLanguage } from 'vue-multilanguage'
import { english } from '@/languages/english.js'
import { russian } from '@/languages/russian.js'

Vue.use(MLInstaller)

export default new MLCreate({
  initial: 'russian',
  save: process.env.NODE_ENV === 'production',
  languages: [
    new MLanguage('english').create(english),

    new MLanguage('russian').create(russian)
  ]
})